import React from 'react'
import { Trans } from '@lingui/macro'
import { useDispatch, useSelector } from 'react-redux'
import { IdStoresState } from 'model/dashboardStores/dStoresReducer'
import { CheckCircleIcon, DotsVerticalIcon, MinusSmIcon, XCircleIcon } from '@heroicons/react/outline'
import { ButtonLink } from 'components/UI/ButtonLink/ButtonLink'
import { getColor } from 'components/utils'
import { Alert } from 'components/UI/Alert/Alert'

import { typeDataStoresBulkActions } from '../index'

import {
    dStoresSetDetailItemAC
} from 'model/dashboardStores/dStoresActionCreators'
import { numberCurrencyFormat } from 'constants/convertToLocalCurrency';

// Type
export type typeTableHeader = {
    variant?: string
    bulkOperations?: typeDataStoresBulkActions
}

// Header data component
export const TableHeader: React.FC<typeTableHeader> = () => {


    return (
        <>

            <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Name</Trans>
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Address</Trans>
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Phone</Trans>
            </th>
            {/*<th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">*/ }
            {/*    <Trans>Industry</Trans>*/ }
            {/*</th>*/ }
            <th scope="col"
                className="px-6 py-3 text-xs font-medium uppercase tracking-wider text-center">
                <Trans>Is active</Trans>
            </th>
            {process.env.REACT_APP_ENCASHMENT === 'true' && <th scope="col"
                 className="px-6 py-3  text-xs font-medium  uppercase tracking-wider text-right">
                <Trans>Cash balance in store</Trans>
            </th>}
            <th scope="col" className="w-1">
            </th>

        </>
    )
}

// Type
export type typeAction = {
    title: JSX.Element,
    disableSwitcher?: boolean,
    action: (id: string) => void,
}

export type typeTableBody = {
    variant?: string
    setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>
    rowsActions: typeAction[]
}


// Body data component
export const TableBody: React.FC<typeTableBody> = ({ variant, setOpenPopupDetails, rowsActions }) => {

    const color = getColor(variant)

    const dispatch = useDispatch()

    const tableData = useSelector((state: { dStores: IdStoresState }) => state.dStores.data)


    const onCellClickHandler = (e: React.MouseEvent<HTMLTableDataCellElement, MouseEvent>, id: string) => {
        dispatch(dStoresSetDetailItemAC(id))
        setOpenPopupDetails(true)
    }
    let component

    if (tableData.length) {
        component = tableData.map((item, index) => {
            return (
                <tr key={ item.id }
                    className={ `${ index % 2 === 0 ? 'bg-white' : 'bg-gray-50' } hover:bg-${ color }-50` }>

                    <td className="px-4 py-3  text-sm font-medium text-gray-900 break-all cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>
                        { item.name } { item.deleted &&
                        <span className={ 'text-xs text-gray-400 font-normal' }><Trans>(deleted)</Trans></span> }</td>
                    <td className="px-4 py-3 text-sm text-gray-500 cursor-pointer break-all"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>
                        { item.address ? item.address :
                            <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div> }
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>
                        { item.phoneNumber ? item.phoneNumber :
                            <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div> }
                    </td>
                    {/*<td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer"  onClick={(e) => onCellClickHandler(e, item.id)}>*/ }
                    {/*    {item.industry?.name? item.industry.name: <div className="flex"><MinusSmIcon className="h-5 w-5 text-gray-400"/></div>}*/ }
                    {/*</td>*/ }
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>
                        <div className="flex justify-center">
                            { !item.deleted ? <CheckCircleIcon className="h-5 w-5 text-grey-400"/> :
                                <XCircleIcon className="h-5 w-5 text-gray-300"/> }
                        </div>
                    </td>

                    {process.env.REACT_APP_ENCASHMENT === 'true' && <td className="px-4 py-3 text-right whitespace-nowrap text-sm text-gray-500 cursor-pointer"
                         onClick={(e) => onCellClickHandler(e, item.id)}>
                        {item.cash_balance ? numberCurrencyFormat(item.cash_balance) : (item.cash_balance === null ?
                            <div className="flex justify-center"><MinusSmIcon className="h-5 w-5 text-gray-400"/>
                            </div> : numberCurrencyFormat(0))}
                    </td>}

                    <td className="whitespace-nowrap text-sm text-gray-500 pr-2">
                        <div className="relative flex">
                            { !item.deleted && <div className=" row-action-block">
                                <DotsVerticalIcon className="row-action-list-open-button h-5 w-5 text-gray-900"/>
                                <div className="row-action-list">
                                    <div className="flex gap-x-4">
                                        { rowsActions.map((actionItem, ActionIndex) => {
                                            return item.deleted ? null :
                                                <ButtonLink key={ ActionIndex } type={ 'button' }
                                                            label={ actionItem.title }
                                                            onClick={ () => actionItem.action(item.id) }/>
                                        }) }
                                    </div>
                                </div>
                            </div> }
                        </div>
                    </td>
                </tr>
            )
        })
    } else {
        component = <tr>
            <td className="p-2" colSpan={ 6 }>
                <Alert className="w-full" type={ 'info' }
                       title={ <Trans>The store list is empty. Contact support with a request to creat
                           stores.</Trans> }/>
            </td>
        </tr>
    }

    return (
        <>
            { component }
        </>
    )
}
